export default __webpack_public_path__ + "static/media/logo-tawa.ac76631b.svg";